import React, {Component} from "react";
import banner from '../../assets/images/Banner.jpg';
import banner1 from '../../assets/images/tour2.jpg';
import banner2 from '../../assets/images/tour4.jpg';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';


const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 1
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};

export default class Banner extends Component{
    // constructor(){
    //     super()
    // }

    render(){
        return(
            <div style={{marginTop:'90px'}}>
            <div className="container-fluid">
            {/*<button style={{marginLeft:'10px'}} type="button" variant="light" className="profile-entry-cancel-btn btn" onClick={() => this.props.showNotification()}>Send</button>*/}
            <Carousel
            swipeable={true}
            draggable={true}
            responsive={responsive}
            showDots={false}
            infinite={true}
            arrows={true}
          //  autoPlay={true}
            autoPlaySpeed={1000}
            keyBoardControl={true}
            customTransition="all .5"
            transitionDuration={1000}
            containerclassName="carousel-container"
            // style={{marginLeft:'20px'}}
            className="tour-details-crousel"
            responsive={responsive}>
           
            <div className="home-banner">
            <div className="row" style={{height:'100%'}}>
            <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="home-banner-content-div">
            <h4>Welcome to Kinship Living</h4>
            <p>A place where you can attend virtual events, engage with like minded individuals and get access to exclusive experiences</p>
            <button className="btn" onClick={()=>this.props.HandleRouting('login')}>Get Started for Free</button>
            </div>
            
            
            </div>
    
            <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="home-banner-img-div">
            <img src={banner} alt="loading..."/>
            </div>
            </div>
            </div>
            </div>


            <div className="home-banner">
            <div className="row" style={{height:'100%'}}>
            <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="home-banner-content-div">
            <h4>Welcome to Kinship Living</h4>
            <p>A place where you can attend virtual events, engage with like minded individuals and get access to exclusive experiences</p>
            <button className="btn" onClick={()=>this.props.HandleRouting('login')}>Get Started for Free</button>
            </div>
            
            
            </div>
    
            <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="home-banner-img-div">
            <img src={banner1} alt="loading..."/>
            </div>
            </div>
            </div>
            </div>

            <div className="home-banner">
            <div className="row" style={{height:'100%'}}>
            <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="home-banner-content-div">
            <h4>Welcome to Kinship Living</h4>
            <p>A place where you can attend virtual events, engage with like minded individuals and get access to exclusive experiences</p>
            <button className="btn" onClick={()=>this.props.HandleRouting('login')}>Get Started for Free</button>
            </div>
            
            
            </div>
    
            <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="home-banner-img-div">
            <img src={banner2} alt="loading..."/>
            </div>
            </div>
            </div>
            </div>
           
           
        </Carousel>


        </div>
            </div>
        )
    }
}